import { PageNotFound } from '@crehana/compass.ui/page-not-found';

export const ProductRouteNotFound = () => {
  return <PageNotFound />;
};
